$(function () {

    $('.popupDialog').each(function(){
        $(this).popupDialog();
    });

    // skryt atributy pri konkretnom objednavkovom formulari
    $('form.addToCart tr.attribRow').hide();

    var pointOrderTrigger = $('form.addToCart input[name="pointorder"]');
    if (pointOrderTrigger.length) {
        pointOrderTrigger.on('click', function(){
            var form = pointOrderTrigger.closest('form');
            var tr = form.find('.pointOrderAmount');
            if (tr.length) {
                if (pointOrderTrigger.is(':checked')) {
                    tr.show();
                } else {
                    tr.hide();
                }
            }
        });
    }

    if ($('#myCarousel').length) {
        const myCarousel = new Carousel(document.querySelector("#myCarousel"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Autoplay: false,
        });
    }

    if ($('#myCarousel-mobile').length) {
        const myCarouselMobile = new Carousel(document.querySelector("#myCarousel-mobile"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: true,
            Navigation: false,
            Autoplay: false,
        });
    }

    if ($('#carouselGallery').length) {
        const carouselGallery = new Carousel(document.querySelector("#carouselGallery"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });
    }

    // Carousel - Súvisiace produkty
    if ($('#products-crosssell').length) {
        const carouselCrosssell = new Carousel(document.querySelector("#products-crosssell"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselCrosssell);
    }

    // Carousel - Odporúčané produkty
    if ($('#products-alternative').length) {
        const carouselAlternative = new Carousel(document.querySelector("#products-alternative"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselAlternative);
    }

    // Carousel - Alternatívne produkty
    if ($('#products-upsell').length) {
        const carouselUpsell = new Carousel(document.querySelector("#products-upsell"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselUpsell);
    }

    // Carousel - Produkty použité v inšpirácii
    if ($('#carouselProducts').length) {
        const carouselProducts = new Carousel(document.querySelector("#carouselProducts"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselProducts);
    }

    let tooltipClub = document.getElementById('tooltip-club');
    if (tooltipClub) {
        tippy('#tooltip-club', {
            content: tooltipClub.getAttribute('data-tooltip'),
        });
    }

    let tooltipPoints = document.getElementById('tooltip-points');
    let tooltipPointsText = document.getElementById('tooltip-points-text');
    let placement = window.innerWidth > 780 ? 'right' : 'bottom';
    if (tooltipPoints && tooltipPointsText) {
        tippy('#tooltip-points', {
            content: tooltipPointsText.innerHTML.replaceAll('{{b}}', "<b>").replaceAll('{{/b}}', "</b>"),
            placement: placement,
            allowHTML: true,
        });
    }

    let productVariants = $('#productVariants');
    if (productVariants.length) {

        let productVariantsStock = {};
        try {
            $.getJSON('/catalog/product/variant-stock-quantity/id/' + productVariants.data('id'), function (response) {
                productVariantsStock = response;
            });
        } catch (e) {
            console.log(e);
        }

        let productVariantsCount = productVariants.find('.variants').length;

        productVariants.on('click', '.variants__item', function () {
            let variants = productVariants.find('.variants__item--active');

            if (variants.length === productVariantsCount) {
                let code = productVariants.data('plu');
                variants.each(function () {
                    code += $(this).data('code');
                });

                let deliveryDate = $('div.product-delivery-date');
                let deliveryStock = $('div.product-detail__stock');
                const deliveryDays = $('#deliveryDays').val();
                if (productVariantsStock[code] && productVariantsStock[code] > 0) {
                    if (productVariantsStock[code] < 6) {
                        deliveryStock.html('<div class="product-detail__in-stock">' + __('Skladom') + ' ' + productVariantsStock[code] + __('ks') + '</div>');
                    } else {
                        deliveryStock.html('<div class="product-detail__in-stock">' + __('Skladom') + '</div>');
                    }
                    deliveryDate.find('strong').text(__('U Vás už do') + ' 5 ' + __('dní'));
                    deliveryDate.removeClass('product-detail__delivery-date-30').addClass('product-detail__delivery-date');
                } else {
                    deliveryStock.html('<div class="product-detail__out-off-stock">' + __('Nie je skladom') + '</div>');
                    deliveryDate.find('strong').text(deliveryDate.data('out'));
                    if(deliveryDays > 5){
                        deliveryDate.removeClass('product-detail__delivery-date').addClass('product-detail__delivery-date-30');
                    } else {
                        deliveryDate.removeClass('product-detail__delivery-date-30').addClass('product-detail__delivery-date');
                    }
                }
            }
        });
    }

    $(".moreInfo").click(function() {
        var target = $(this).data("target");
        $("#" + target).toggleClass('supplier-hidden');
    });
});
